import { createAction } from '@reduxjs/toolkit';

export const eventDataCleanUp = createAction('eventDataCleanUp');
